import ExtensionCapability from '../../capability';
import type Instance from '../../instance';
import { Specs } from '@doxyme/extensions-common';
import { BackendRuntime } from '../../runtimes/backend/backendRuntime';

type Constraints = Specs.Backend.Constraints;

const { Backend } = Specs;

type BackendConfig = Specs.Backend.Config;

function mkRuntime(instance: Instance, config: BackendConfig): BackendRuntime {
  const runtime = new BackendRuntime(instance, config);
  instance.addRuntime(runtime);
  return runtime;
}

export default class BackendCapability extends ExtensionCapability<Constraints> {
  static readonly id = Backend.id;

  private readonly runtimes: Record<string, BackendRuntime> = {};

  constructor() {
    super(Backend);
  }

  override addInstance(instance: Instance): void {
    super.addInstance(instance);
    const configs = this.configsBy(instance);
    this.attachRuntimes(instance, configs);
  }

  protected attachRuntimes(instance: Instance, configs: BackendConfig[]): void {
    for (const config of configs) {
      const runtimeId = BackendRuntime.runtimeId(instance, config);
      let runtime = this.runtimes[runtimeId];

      if (!runtime) {
        runtime = mkRuntime(instance, config);
        this.runtimes[runtime.id] = runtime;
      }
    }
  }
}
